import DOMPurify from 'dompurify';
import { marked } from 'marked';
import { getThumbSrcSet, getThumbUrl } from '../../../shared/api';
import type { MessageTextProps } from '../types';

marked.setOptions({
  breaks: true,
  gfm: true,
});

const renderer = new marked.Renderer();
renderer.image = ({ href, title, text }) => {
  const isMediaUrl = href && (href.startsWith('/media/') || href.includes('/media/'));

  if (isMediaUrl) {
    const srcSet = getThumbSrcSet(href, [400, 800, 1200]);
    const source = getThumbUrl(href, 800);
    const titleAttribute = title ? ` title="${title}"` : '';

    return `<img src="${source}" srcset="${srcSet}" sizes="(max-width:600px) 400px,(max-width:1200px) 800px,1200px" alt="${text}"${titleAttribute} loading="lazy">`;
  }

  return `<img src="${href}" alt="${text}" loading="lazy">`;
};

marked.use({ renderer });

const MessageText = ({ content }: MessageTextProps) => {
  if (!content) {
    return null;
  }

  const renderedMarkdown = marked.parse(content, { async: false }) as string;
  const html = DOMPurify.sanitize(renderedMarkdown, {
    ADD_TAGS: ['img'],
    ADD_ATTR: ['src', 'alt', 'class'],
    ALLOW_DATA_ATTR: false,
    FORCE_BODY: false,
    ALLOWED_URI_REGEXP: /^(https?:\/\/|\/media\/)/i,
  });

  return <div className="message-text markdown-body" dangerouslySetInnerHTML={{ __html: html }} />;
};

export default MessageText;
